import type { SpacingValue } from '../../theme';
import { colors } from '../../theme/colors';

export function getDetailsCardOuterPadding(padding: string | SpacingValue): SpacingValue {
  if (typeof padding === 'number') {
    return padding;
  }

  switch (padding) {
    case 'default':
      return 12;
    case 'none':
      return 0;
    case 'narrow':
      return 4;
    default:
      return 12;
  }
}

interface BackgroundColorOptions {
  isHovering?: boolean;
  isHighlighted?: boolean;
}

export function getDetailsCardColor(color: string): string {
  switch (color) {
    case 'white':
      return '#FFFFFF';
    case 'light-grey':
      return colors.steel[50];
    case 'light-blue':
      return colors.brand[100];
    case 'light-yellow':
      return colors.fire[100];
    default:
      return color;
  }
}

export function getDetailsCardBackgroundColor(
  color: string,
  { isHovering, isHighlighted }: BackgroundColorOptions,
): string {
  if (isHighlighted) {
    return colors.brand[100];
  }

  if (isHovering) {
    return colors.steel[50];
  }

  switch (color) {
    case 'white':
      return '#FFFFFF';
    case 'light-grey':
      return colors.steel[50];
    case 'light-blue':
      return colors.brand[100];
    case 'light-yellow':
      return colors.fire[100];
    default:
      return color;
  }
}

/**
 * This constants in meant to use as a padding for the inner content of the card.
 * For default outer padding this achieves 16px in total: 12 + 4
 */
export const INNER_PADDING = 4;

/**
 * Maps SpacingValue to complete Tailwind CSS padding class names
 * Using static strings to ensure Tailwind CSS purging works correctly
 */
const spacingToTailwindPaddingClassMap: Record<number, string> = {
  0: 'p-0',
  2: 'p-0.5',
  4: 'p-1',
  8: 'p-2',
  12: 'p-3',
  16: 'p-4',
  20: 'p-5',
  24: 'p-6',
  32: 'p-8',
  40: 'p-10',
  48: 'p-12',
  56: 'p-14',
  64: 'p-16',
  72: 'p-18',
  80: 'p-20',
  88: 'p-22',
  96: 'p-24',
  104: 'p-26',
  112: 'p-28',
  120: 'p-30',
  128: 'p-32',
  256: 'p-64',
};

/**
 * Returns the appropriate Tailwind CSS padding class for DetailCard outer padding
 * Equivalent to getDetailsCardOuterPadding but returns Tailwind classes instead of pixel values
 */
export function getDetailsCardOuterPaddingClass(padding: string | SpacingValue): string {
  if (typeof padding === 'number') {
    return spacingToTailwindPaddingClassMap[padding] || 'p-3'; // default to p-3 if not found
  }

  switch (padding) {
    case 'default':
      return 'p-3'; // 12px
    case 'none':
      return 'p-0'; // 0px
    case 'narrow':
      return 'p-1'; // 4px
    default:
      return 'p-3'; // 12px
  }
}
